import { useResetFilter, useResetFilters } from "../components/elements/SearchResults/components/boundsFilterHooks";
import { StoreKeys } from "../constants/filtersMeta";

export const useFiltersReset = () => {
  const _resetFilter = useResetFilter();
  const resetFilters = useResetFilters();

  const resetFilter = (filters: StoreKeys[]) => {
    filters.forEach((filter) => _resetFilter(filter));
  };

  const resetAllFilters = () => {
    resetFilters();
  };

  return {
    resetFilter,
    resetAllFilters
  };
};
